import { PropsWithChildren, useState } from 'react'
import { useModal } from '@iveco-ti/iveco-ds'

import { ModalActions, ModalContext } from '../hooks/useModalProvider'

const INITIAL_MODAL_STATE: ModalActions = {
  type: 'primary',
  title: '',
  description: undefined,
  cancelText: undefined,
  confirmText: undefined,
  onCancel: undefined,
  onConfirm: undefined,
  isLoading: false,
}

export const ModalProvider = (props: PropsWithChildren) => {
  const [modalState, setModalState] =
    useState<ModalActions>(INITIAL_MODAL_STATE)
  const { open, close } = useModal('global-modal')

  const handleModal = (props: Omit<ModalActions, 'handleModal'>) => {
    setModalState((prev) => ({ ...prev, ...props }))
    open()
  }

  const toggleLoading = () => {
    setModalState((prev) => ({ ...prev, isLoading: !prev.isLoading }))
  }

  const resetModal = () => {
    setModalState(INITIAL_MODAL_STATE)
    close()
  }

  return (
    <ModalContext.Provider
      value={{ ...modalState, handleModal, toggleLoading, resetModal }}
    >
      {props.children}
    </ModalContext.Provider>
  )
}
